import { Injectable, inject } from '@angular/core';
import { Confirmation, ConfirmationService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class ConfirmationDialogService {
  private confirmationService = inject(ConfirmationService);
  private translate = inject(TranslateService);

  confirm(confirmation: Confirmation) {
    const defaultConfirmation: Confirmation = {
      ...confirmation,
      rejectVisible: confirmation.rejectVisible !== undefined ? confirmation.rejectVisible : true,
      header: confirmation.header || this.translate.instant('CONFIRMATION'),
      acceptLabel: confirmation.acceptLabel || this.translate.instant('YES'),
      rejectLabel: confirmation.rejectLabel || this.translate.instant('NO')
    };
    this.confirmationService.confirm(defaultConfirmation);
  }

  close() {
    this.confirmationService.close();
  }
}




